import React, { useEffect, useRef, useState } from "react";

const ScreenText = ({ screen, i, setCurrentImg }) => {
  const [showAnimation, setShowAnimation] = useState(false);
  const ref = useRef(null);
  //   console.log(ref);

  const toggleAnimation = (e) => {
    if (e[0].isIntersecting) {
      setShowAnimation(true);
      setCurrentImg(i);
    }
  };

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.6,
  };
  useEffect(() => {
    const observer = new IntersectionObserver(toggleAnimation, options);
    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  });

  return (
    <div
      className={`screen-text ${showAnimation ? "text-visible" : ""}`}
      ref={ref}
    >
      <div className="screen-heading">{screen.heading}</div>
      <div className="mobile-mockup-wrapper mobile-view">
        <div className="mobile-mockup">
          <div className="mobile-mockup-screen absolute-center">
            <img
              src={screen.mobile_img}
              alt="mobile"
              className="mobile-screen-image"
            />
          </div>
        </div>
      </div>
      <div className="screen-description">{screen.description}</div>
    </div>
  );
};

export default ScreenText;
